/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {ApiConfig} from '../api/api';
import {LocalScannedCreativeInfo} from '../session/local-scanned-creative-info';
import {AdnHttpService} from './adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from './create-adn-http-resource';
import {AuthHttpInterceptorService} from '../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../app/common/directives/error/api-error-handler.service';



@Injectable({
  providedIn: 'root'
})
export class AdnCheckerService {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  getBlockedCreatives(forceCall?: boolean): Promise<any> {
    const blockedCreatives = LocalScannedCreativeInfo.obtain().getScannedCreatives(forceCall);
    if (blockedCreatives.length > 0) {
      return Promise.resolve(blockedCreatives);
    }
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['adnchecker', 'creativeblocks']),
      params: _.assign({}, {format: 'json'})
    }).then((nextBlockedCreatives: any) => {
      LocalScannedCreativeInfo.obtain().setScannedCreatives(nextBlockedCreatives);
      return nextBlockedCreatives;
    });
  }

  scanResultsByCreative(): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['adnchecker', 'creativeblocks']),
      params: _.assign({}, {format: 'json'})
    });
  }

  scanResults(status: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['adnchecker', 'creativeblocksbynetwork']),
      params: _.assign({}, {format: 'json', status})
    });
  }

  checkId(id: string, forceRerun?: boolean, hashResults?: boolean, ignoreScanHistory?: boolean): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['adnchecker', id]),
      params: _.assign({}, {
        format: 'json',
        concise: true,
        forceRerun: !!forceRerun,
        hashResults: !!hashResults,
        ignoreScanHistory: !!ignoreScanHistory
      })
    });
  }
}
